import React, { useState } from "react";
import { useGlobalContext } from "../../context/global";
import useUserDetails from "../../helper/userData/useUserDetails";
import { useSignOut } from "react-auth-kit";
import { useNavigate } from "react-router-dom";
import LogoutIcon from "../../assets/svgs/logout.svg";
import switchIcon from "../../assets/svgs/switch.svg";
import {
  Box,
  Menu,
  MenuItem,
  Typography,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import ArrowDropUp from "@mui/icons-material/ArrowDropUp";

const HeaderDrawer = ({ setDrawer, drawer }) => {
  const {
    setShow,
    setModalFor,
    noMultiuserClients,
    setNoMultiuserClients,
    updatePlatform,
    setClientId,
    setClientAccountId,
  } = useGlobalContext();

  const [userDetails] = useUserDetails();
  const isMultiuser = userDetails?.user?.multiUser === "yes" ? true : false;
  const logout = useSignOut();
  const navigate = useNavigate();

  const clientName =
    typeof window !== "undefined"
      ? JSON.parse(localStorage.getItem("clientName") || '""') || "Client Name here"
      : "Client Name here";
  const firstLetter = clientName
    ? String(clientName).charAt(0).toUpperCase()
    : "";

  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);

  const handleClick = (event) => {
    if (anchorEl) {
      setAnchorEl(null);
      if (setDrawer) setDrawer(false);
    } else {
      setAnchorEl(event.currentTarget);
      if (setDrawer) setDrawer(true);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    if (setDrawer) setDrawer(false);
  };

  const showClientsForNoMultiuser = noMultiuserClients?.length > 1;

  const clientSwitch = () => {
    handleClose();
    setShow(true);
    setModalFor("switch-client");
  };

  const handleLogout = () => {
    handleClose();
    logout();
    localStorage.clear();
    setClientId(null);
    setClientAccountId("");
    navigate("/login");
    setNoMultiuserClients([]);
    updatePlatform("amazon");
  };

  const menuItemsConfig = [
    {
      label: "Switch Client",
      displayLabel: showClientsForNoMultiuser && !isMultiuser ? "Switch Account" : "Switch Client",
      icon: switchIcon,
      action: clientSwitch,
      show: isMultiuser || (showClientsForNoMultiuser !== false && isMultiuser === false),
    },
    { label: "Log Out", icon: LogoutIcon, action: handleLogout, show: true },
  ];

  const open = menuOpen;

  return (
    <>
      <Box
        aria-controls={open ? "client-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.25,
          minWidth: 180,
          maxWidth: 260,
          height: 36,
          px: 1.5,
          py: 0.5,
          borderRadius: 1,
          border: "1px solid",
          borderColor: "#c4c4c4",
          bgcolor: "background.paper",
          cursor: "pointer",
          "&:hover": {
            borderColor: "#c4c4c4",
            bgcolor: "grey.50",
          },
        }}
      >
        <Box
          sx={{
            width: 22,
            height: 22,
            borderRadius: 1,
            bgcolor: "#C2185B",
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            typography: "body1",
            fontWeight: 600,
            fontSize: "1rem",
          }}
        >
          {firstLetter}
        </Box>
        <Typography
          variant="body2"
          sx={{
            flex: 1,
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            color: "grey.800",
            fontWeight: 500,
          }}
        >
          {clientName.length > 25 ? clientName.slice(0, 25) + "..." : clientName}
        </Typography>
        {open ? (
          <ArrowDropUp
            sx={{
              color: "grey.600",
              fontSize: 24,
              flexShrink: 0,
            }}
          />
        ) : (
          <ArrowDropDown
            sx={{
              color: "grey.600",
              fontSize: 24,
              flexShrink: 0,
            }}
          />
        )}
      </Box>
      <Menu
        id="client-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableScrollLock
        marginThreshold={8}
        MenuListProps={{
          "aria-labelledby": "client-select",
          sx: { py: 1, paddingTop: 1, paddingBottom: 1 },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          elevation: 8,
          sx: {
            mt: 1.5,
            minWidth: 200,
            maxHeight: "calc(100vh - 32px)",
            borderRadius: 2,
          },
        }}
      >
        {menuItemsConfig.map((config, index) => {
          if (config.show === false) return null;
          const isIconReactNode = config.label === "Setup";
          return (
            <MenuItem
              key={index}
              onClick={config.action}
              sx={{
                py: 1.25,
                px: 2,
                gap: 1.5,
                "&:hover": {
                  bgcolor: "grey.100",
                },
              }}
            >
              <ListItemIcon sx={{ minWidth: 28 }}>
                {isIconReactNode ? (
                  config.icon
                ) : (
                  <img
                    src={config.icon}
                    alt=""
                    style={{ width: 20, height: 20, objectFit: "contain" }}
                  />
                )}
              </ListItemIcon>
              <ListItemText
                primary={config.displayLabel ?? config.label}
                primaryTypographyProps={{
                  variant: "body2",
                  fontWeight: 500,
                  color: "grey.800",
                }}
              />
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default HeaderDrawer;
